import { render, staticRenderFns } from "./StreamButton.vue?vue&type=template&id=35ddee4a&"
import script from "./StreamButton.vue?vue&type=script&lang=js&"
export * from "./StreamButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ddee4a')) {
      api.createRecord('35ddee4a', component.options)
    } else {
      api.reload('35ddee4a', component.options)
    }
    module.hot.accept("./StreamButton.vue?vue&type=template&id=35ddee4a&", function () {
      api.rerender('35ddee4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trial/videoTrial/components/StreamButton.vue"
export default component.exports